import React, {Component} from 'react';
import MaterialIcon from '../../../MaterialIcon';
import PredicateItem from "./PredicateItem";
import defaultPredicateOption from './const/defaultPredicateOption';
import defaultSwitchPredicateOption from "./const/switch/defaultSwitchPredicateOption";


export default class PredicateGroup extends Component {
    constructor(props) {
        super(props);
        let initialPredicate = this.props.predicate;
        if (Array.isArray(initialPredicate.predicates)) {
            initialPredicate.predicates = initialPredicate.predicates.map((p, index) => ({
                ...p,
                id: index + 1
            }));
        }

        this.state = {
            predicate: initialPredicate,
            showAddNew: false
        };
        this.defaultPredicateOption = props.predicateBlockType === "switch" ? defaultSwitchPredicateOption : defaultPredicateOption
        this.onPredicateOptionUpdate = this.onPredicateOptionUpdate.bind(this);
        this.toggleAndOr = this.toggleAndOr.bind(this);
        this.onClickAddNewButton = this.onClickAddNewButton.bind(this);
        this.onClickNew = this.onClickNew.bind(this);
    }



    onPredicateOptionUpdate(index, predicateData) {
        this.setState(prevState => {
           let predicate = {...prevState.predicate};
           predicate.predicates[index] = {...predicateData, id: predicate.predicates[index].id};
           return {predicate};
        }, () => {
            this.props.onPredicateOptionUpdate(this.state.predicate);
        });
    }

    onPredicateDelete(index) {
        let predicate = {...this.state.predicate};
        predicate.predicates = predicate.predicates.filter((value, predicateIndex) => predicateIndex !== index);

        this.setState({
            predicate: {
                ...predicate
            }
        }, () => {
            this.props.onPredicateOptionUpdate(predicate);
        });
    }

    toggleAndOr() {
        const type = this.state.predicate.type === "and" ? "or" : "and";
        this.setState(prevState => (
            {
                predicate: {
                    ...prevState.predicate,
                    type
                }
            }
        ), () => {
            this.props.onPredicateOptionUpdate({...this.state.predicate});
        })
    }

    onClickAddNewButton() {
        this.setState(prevState => ({
            showAddNew: !prevState.showAddNew
        }));
    }

    onClickNew(isCondition) {
        let newCondition;
        let nextPredicateId = 1;

        if (this.state.predicate.predicates.length > 0) {
            const maxId = Math.max(...this.state.predicate.predicates.map(p => p.id));
            nextPredicateId = maxId + 1;
        }

        if (isCondition) {
            newCondition = this.props.defaultPredicateValue ? {
                ...this.props.defaultPredicateValue,
                id: nextPredicateId
            } : {...this.defaultPredicateOption, id: nextPredicateId};
        } else {
            newCondition = {
                type: "and",
                predicates: [],
                id: nextPredicateId
            };
        }

        this.setState(prevState => ({
            predicate: {
                ...prevState.predicate,
                predicates: [
                    ...prevState.predicate.predicates,
                    newCondition
                ]
            },
            showAddNew: false
        }), () => {
            this.props.onPredicateOptionUpdate({...this.state.predicate});
        });
    }

    render() {
        return (
            <div className="predicate-group-header-wrapper">
                <div className="predicate-group-header">
                    <div
                        className={"label" + (this.state.predicate.type === "and" ? " and-label" : " or-label")}
                        onClick={this.toggleAndOr}>{(this.state.predicate.type === "and" ? "AND" : "OR")}
                    </div>
                    <div className="label"
                         onClick={this.toggleAndOr}>{(this.state.predicate.type === "and" ? "OR" : "AND")}
                    </div>
                    <span className="delete" onClick={() => this.props.onPredicateDelete()}>
                        <MaterialIcon icon="close"/>
                    </span>
                </div>
                <div className={"predicate-group " + this.state.predicate.type}>
                    {
                        this.state.predicate.predicates.map((predicate, index) => (
                            (predicate.type === "and" || predicate.type === "or") ?
                            <PredicateGroup key={predicate.id}
                                            predicate={predicate}
                                            defaultPredicateValue={this.props.defaultPredicateValue}
                                            disableArea={this.props.disableArea}
                                            userProperties={this.props.userProperties}
                                            itemProperties={this.props.itemProperties}
                                            contextProperties={this.props.contextProperties}
                                            predicateBlockType={this.props.predicateBlockType}
                                            onPredicateOptionUpdate={(data) => this.onPredicateOptionUpdate(index, data)}
                                            onPredicateDelete={() => this.onPredicateDelete(index)}/>
                                                                                  :
                             (<PredicateItem key={predicate.id}
                                             {...predicate}
                                            index={predicate.id}
                                             userProperties={this.props.userProperties}
                                             itemProperties={this.props.itemProperties}
                                             disableArea={this.props.disableArea}
                                             contextProperties={this.props.contextProperties}
                                             predicateBlockType={this.props.predicateBlockType}
                                             onPredicateOptionUpdate={(data) => this.onPredicateOptionUpdate(index, data)}
                                             onPredicateDelete={() => this.onPredicateDelete(index)}/>)

                        ))
                    }
                </div>
                <div className="add-new-options">
                    <button className={"add-new-button " + this.state.predicate.type}
                            onClick={this.onClickAddNewButton}><span>+</span></button>

                    <div onClick={() => this.onClickNew(true)}
                         className={"new " + (this.state.showAddNew ? "active" : "")}>New Condition
                    </div>
                    <div onClick={() => this.onClickNew(false)}
                         className={"new " + (this.state.showAddNew ? "active" : "")}>New
                        Group
                    </div>
                </div>
            </div>
        );
    }
}
